module.exports = __webpack_public_path__ + "img/land_tower_true.cb18d915.png";